/**
 * Resolves the CMS page slug for the current document.
 *
 * Mirrors `normalisePageSlug` in `@siteflow/shared` so the SDK and the API agree
 * on which page a request is for, without importing the (zod-dependent) package.
 */
export function resolvePageSlug(
  location: Pick<Location, 'pathname'> | { pathname?: string },
  override?: string,
): string {
  const raw = (override ?? location.pathname ?? '/').trim();
  let slug = raw.split('?')[0] ?? '';
  slug = slug.split('#')[0] ?? '';
  if (!slug) return '/';
  if (slug.charAt(0) !== '/') slug = `/${slug}`;
  slug = slug.replace(/\/index\.html?$/i, '/').replace(/\.html?$/i, '');
  if (slug.length > 1 && slug.charAt(slug.length - 1) === '/') slug = slug.slice(0, -1);
  return slug.toLowerCase() || '/';
}
